import { render, staticRenderFns } from "./ClientInteractionModal.vue?vue&type=template&id=121693b0&scoped=true&"
import script from "./ClientInteractionModal.vue?vue&type=script&lang=js&"
export * from "./ClientInteractionModal.vue?vue&type=script&lang=js&"
import style0 from "./ClientInteractionModal.vue?vue&type=style&index=0&id=121693b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121693b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardTitle,VDialog,VIcon})
